import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	setAsDefaultSuccessFlagTitle: {
		id: 'navigation-kit-tab-menu.services.set-as-default.set-as-default-success-flag-title',
		defaultMessage: '{viewName} set as default view',
		description: 'Title for the success flag when the default view is updated.',
	},
	setAsDefaultSuccessFlagDescription: {
		id: 'navigation-kit-tab-menu.services.set-as-default.set-as-default-success-flag-description',
		defaultMessage: '{viewName} will be the default view for everyone.',
		description: 'Description for the success flag when the default view is updated.',
	},
	setAsDefaultErrorFlagTitle: {
		id: 'navigation-kit-tab-menu.services.set-as-default.set-as-default-error-flag-title',
		defaultMessage: "Something's gone wrong",
		description: 'Flag title when the request to set the view as default has failed.',
	},
	setAsDefaultErrorFlagDescription: {
		id: 'navigation-kit-tab-menu.services.set-as-default.set-as-default-error-flag-description',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Flag description when the request to set the view as default has failed.',
	},
	userNotLoggedInErrorFlagTitle: {
		id: 'navigation-kit-tab-menu.services.set-as-default.user-not-logged-in-error-flag-title',
		defaultMessage: "You'll need to log in",
		description: 'Flag title when the request fails due to the user not being logged in.',
	},
	userNotLoggedInErrorFlagDescription: {
		id: 'navigation-kit-tab-menu.services.set-as-default.user-not-logged-in-error-flag-description',
		defaultMessage:
			'You need to be logged in to set this view as default. Please log in and try again.',
		description:
			'Flag description when the request to set the view as default has failed due to the user not being logged in.',
	},
	userNotAdminErrorFlagTitle: {
		id: 'navigation-kit-tab-menu.services.set-as-default.user-not-admin-error-flag-title',
		defaultMessage: "You don't have permission",
		description:
			'Flag title when the request to set the view as default has failed due to the user not being allowed.',
	},
	userNotAdminErrorFlagDescription: {
		id: 'navigation-kit-tab-menu.services.set-as-default.user-not-admin-error-flag-description',
		defaultMessage: 'You are not allowed to manage the navigation.',
		description:
			'Flag description when the request to set the view as default has failed due to the user not being allowed.',
	},
	viewNotDefaultableErrorFlagTitle: {
		id: 'navigation-kit-tab-menu.services.set-as-default.view-not-defaultable-error-flag-title',
		defaultMessage: 'Choose a different default view',
		description:
			'Flag title when the request to set the view as default has failed due to the view not being allowed to be set as default.',
	},
	viewNotDefaultableErrorFlagDescription: {
		id: 'navigation-kit-tab-menu.services.set-as-default.view-not-defaultable-error-flag-description',
		defaultMessage:
			'You can only set the summary, board, list, calendar, or timeline as the default view.',
		description:
			'Flag description when the request to set the view as default has failed due to the view not being allowed to be set as default.',
	},
	viewNotFoundErrorFlagTitle: {
		id: 'navigation-kit-tab-menu.services.set-as-default.view-not-found-error-flag-title',
		defaultMessage: 'This view tab been removed',
		description:
			'Flag title when the request to set the view as default has failed due to the view being removed.',
	},
	viewNotFoundErrorFlagDescription: {
		id: 'navigation-kit-tab-menu.services.set-as-default.view-not-found-error-flag-description',
		defaultMessage: "The tab you're trying to set as default can't be found.",
		description:
			'Flag description when the request to set the view as default has failed due to the view being removed.',
	},
});
